import { ICashierBox, IInOutMovement, IStore } from '../../interfaces/Store';
import {
  useInfiniteQuery,
  useQuery,
} from '@tanstack/react-query';
import { getCashierBoxMovementsHistoryV2, getCashierBoxesV2, getCashierboxesByIdV2 } from '../../services/store.service';

export const useGetCashierboxes = (enabled: boolean, storeId: string) => useQuery<ICashierBox[]>({
  queryKey: ['cashierbox', { storeId: storeId }],
  enabled: enabled,
  queryFn: async ({ queryKey }) => {
    try {
      const [_key, { storeId }] = queryKey
      const res = await getCashierBoxesV2(storeId);
      if (!res?.data?.data?.cashierBoxes) {
        throw new Error('Oh no! Something went wrong while fetching.');
      }
      return res.data.data.cashierBoxes;
    } catch (e: any) {
      console.log('error caught', e['response']?.data?.['errors']);
      throw e;
    }
  }
});

export const useGetCashierboxById = (storeId: string, id: string) => useQuery<ICashierBox>({
  queryKey: ['cashierbox', { _id: id }],
  enabled: !!storeId,
  queryFn: async ({ queryKey }) => {
    try {
      const [_key, { _id: _id }] = queryKey;
      const res = await getCashierboxesByIdV2(storeId, _id);
      if (!res?.data?.data) {
        throw new Error('Oh no! Something went wrong while fetching.');
      }
      return res.data.data;
    } catch (e: any) {
      console.log('error caught', e['response']?.data?.['errors']);
      throw e;
    }
  }
});

export const useGetCashierboxMovementsHistory = (storeId: string, id: string, limit: number) => useInfiniteQuery<IInOutMovement[]>({
  queryKey: ['cashierboxHistory', { _id: id }],
  enabled: !!storeId,
  initialPageParam: 0,
  getNextPageParam: (lastPage, allPages, lastPageParam) => {
    if (lastPage.length === 0) {
      return undefined
    }
    return lastPageParam + 1
  },
  getPreviousPageParam: (firstPage, allPages, firstPageParam) => {
    if ((firstPageParam as number) <= 1) {
      return undefined
    }
    return (firstPageParam as number) - 1
  },
  queryFn: async ({ queryKey, pageParam }: any) => {
    try {
      const [_key, { _id: _id }] = queryKey;
      const res = await getCashierBoxMovementsHistoryV2(storeId, _id, {
        pageNum: pageParam,
        limit: limit
      });

      if (!res?.data?.data?.history?.inOutMovements) {
        throw new Error('Oh no! Something went wrong while fetching.');
      }
      return res.data.data.history.inOutMovements;
    } catch (e: any) {
      console.log('error caught', e['response']?.data?.['errors']);
      throw e;
    }
  }
});
